import React from 'react';

import Screen, {backButton} from 'editor/screens/Screen';
import {COPY, NOT_SUPPORTED_CUSTOMER_MESSAGES} from 'text/errors';

/**
 * A file the pipeline rejected (DQ17). The API's customerMessage is shown only when it is exactly one of the two whitelisted texts. Any other
 * value, an empty one or none gives the fallback body: the API's own text never reaches the user (Global Constraints).
 */
export default function NotSupported({message}) {
    const copy = COPY.screens.notSupported;

    return <Screen title={copy.title} body={[NOT_SUPPORTED_CUSTOMER_MESSAGES.includes(message) ? message : copy.body]} buttons={[backButton]}/>;
}
